import React, { useMemo } from 'react'
import { PopUpLayer, NotifyMe } from '@usap/widgets'
import {
  Box, Button, Loader,
} from '@usap/uicomponents'
import style from './style/constant'
import seoIds from '../../../../../../config/seoIds'
import NotifyMeLabel from '../../../../searchLayoutComponents/mainSectionComponents/ProductCard/NotifyMeLabel'
import { ProceedToCheckoutButton } from '../../Summary/ProceedToCheckout/Regular/ProceedToCheckoutWmo.css'
import useWmoEnabled from '../../../../../hooks/useWmoEnabled'

const Component = ({ data }) => {
  const {
    cartLoading,
    cardId,
    notify,
    setNotify,
    onClickNotify,
    invId,
    siteKey,
    index,
    isDesktop,
    isNotAvailable,
    onAddToCart,
    widgetName,
  } = useMemo(() => ({ ...data }), [data])
  const { addToCard } = seoIds

  const hoverBackground = useMemo(() => (isNotAvailable ? '#ffffff' : '#ffff52'), [isNotAvailable])
  const background = useMemo(() => (isNotAvailable ? '#ffffff' : '#ffce05'), [isNotAvailable])
  const id = useMemo(() => addToCard?.replace('{{key}}', index), [addToCard, index])
  const isWmoEnabled = useWmoEnabled()
  const pageType = __BROWSER__ && window && window.pageType
  const buttonStyle = useMemo(
    () => (
      isNotAvailable && !isDesktop
        ? {
          textAlign: 'left',
          padding: 0,
          borderRadius: 0,
          height: '48px',
        }
        : { padding: '0 12px' }),
    [isDesktop, isNotAvailable],
  )

  const cartLoadingCheckLabel = cartLoading ? 'Adding...' : 'Add to Cart'
  const buttonLabel = useMemo(
    () => (isNotAvailable ? (<NotifyMeLabel widgetName={widgetName} />) : cartLoadingCheckLabel),
    [cartLoadingCheckLabel, isNotAvailable, widgetName],
  )

  return (
    <>
      {cartLoading && <Loader id={cardId} />}
      <PopUpLayer
        flag={notify}
        closePopUp={setNotify}
        PopUpComponent={NotifyMe}
        onClickNotify={onClickNotify}
        id={invId}
        siteKey={siteKey}
      />

      <Box pad={style.buttonWrapper}>
        {isWmoEnabled && pageType === 'cart' ? (
          <ProceedToCheckoutButton
            id={id}
            onClick={onAddToCart}
            disabled={cartLoading}
          >
            {buttonLabel}
          </ProceedToCheckoutButton>
        )
          : (
            <Button
              id={id}
              custom
              hideBorder={!isDesktop}
              background={background}
              hoverBackground={hoverBackground}
              style={buttonStyle}
              borderColor="#cccaca"
              forcedColor="dark-2"
              disabled={cartLoading}
              label={buttonLabel}
              onClick={onAddToCart}
            />
          )}
      </Box>
    </>
  )
}

export default Component
